// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getAssetType,
  getCountryFromCode,
  isAssetInDevelopment,
  isWestfieldAsset,
} from '../../../utils/utils';
import { getCurrentCountry, parseUrl } from '../../../utils/urlUtils';
import Map from '../../../components/googleMaps/Map';
import { AREA_MAP } from '../../../path/areaPath';
import type { History } from '../../../types/commonTypes';
import type { ShoppingCenter } from '../../../types/shoppingCenterType';
import type { OfficePartial } from '../../../types/OfficesType';
import redMarker from '../../../img/red-marker.png';
import yellowMarker from '../../../img/yellow-marker.png';
import greenMarker from '../../../img/green-marker.png';
import westfieldMarker from '../../../img/westfield-marker.png';
import GMMarker from '../../../components/googleMaps/GMMarker';
import GMInfoWindow from '../../../components/googleMaps/GMInfoWindow';
import { assetTypes } from '../../../const';

type Props = {
  history: History,
  location: Location,
  shoppingCenterList: ShoppingCenter[],
  officeList: OfficePartial[],
  isOfficeSelected: boolean,
  apiKey: string,
}

type State = {
  assetType: ?string,
  selectedAsset: ?ShoppingCenter | ?OfficePartial,
  infoPos: {
    x: number,
    y: number,
  },
  ref: ?HTMLElement,
}

const iconHeigth = 40;
const iconWidth = 52;

class AreaMap extends React.Component<Props, State> {
  state: State = {
    assetType: null,
    selectedAsset: null,
    selectedMarker: null,
    infoPos: { x: 0, y: 0 },
    ref: null,
    mapIsReady: false,
  };

  lat;
  long;
  zoom;
  mapRef;

  constructor(props) {
    super(props);
    const country = getCurrentCountry(props.location.search);
    this.lat = country ? country.lat : 52.746148;
    this.long = country ? country.long : 23.620785;
    this.zoom = country ? country.zoom : 5;
  }

  updateCurrentCountry = (newCountry) => {
    if (newCountry && parseUrl(window.location.search).area !== newCountry.id) {
      this.props.history.push(`${AREA_MAP}?area=${newCountry.id}`);
    }
  };

  handleMarkerHover = (props, marker, e, asset, assetType) => {
    const scale = Math.pow(2, props.map.getZoom());
    const nw = new google.maps.LatLng(
      props.map.getBounds().getNorthEast().lat(),
      props.map.getBounds().getSouthWest().lng(),
    );
    const worldCoordinateNW = props.map.getProjection().fromLatLngToPoint(nw);
    const worldCoordinate = props.map.getProjection().fromLatLngToPoint(marker.getPosition());
    const pixelOffset = new google.maps.Point(
      Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
      Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale),
    );

    this.setState({
      selectedAsset: asset, selectedMarker: marker, infoPos: pixelOffset, ref: null, assetType,
    });
  };

  render() {
    return (
      <div
        ref={(ref) => {
          this.mapRef = ref;
        }}
        style={{ height: '100%', width: '100%' }}
      >

        {this.props.apiKey &&
        <Map
          latitude={this.lat}
          longitude={this.long}
          zoom={this.zoom}
          apiKey={this.props.apiKey}
          updateLocation={(newCountryCode) => {
            this.updateCurrentCountry(getCountryFromCode(newCountryCode));
          }}
          onClick={() => this.setState({
 selectedAsset: null, selectedMarker: null, ref: null, assetType: null,
})}
          googleIsReady={() => this.setState({ mapIsReady: true })}
        >
          <GMInfoWindow
            marker={this.state.selectedMarker}
            visible={!!this.state.selectedAsset}
            className="gmap-info"
          >
            <div>
              {this.state.selectedAsset &&
              <button
                onClick={() => {
                    this.props.history.push(`${getAssetType(this.state.assetType).path}${this.state.selectedAsset.id}`);
                  }}
              >
                <div className="mall-info-container">
                  <i className={`fas ${getAssetType(this.state.assetType).icon} icon`} />
                  <div className="mall-data-container">
                    <div className="mall-name">{this.state.selectedAsset.name}</div>
                    <div
                      className="mall-pcCode"
                    >{this.state.assetType !== assetTypes.office.type ? this.state.selectedAsset.pcCode : this.state.selectedAsset.code}
                    </div>
                  </div>
                </div>
              </button>}
            </div>

          </GMInfoWindow>
          {
            this.state.mapIsReady &&
            (!this.props.isOfficeSelected ?
              this.props.shoppingCenterList.map(shoppingCenter => (
                <GMMarker
                  key={shoppingCenter.id}
                  title={shoppingCenter.name}
                  position={{
                    lat: Number(shoppingCenter.latitude),
                    lng: Number(shoppingCenter.longitude),
                  }}
                  icon={{
                    url: isAssetInDevelopment(shoppingCenter) ? greenMarker :
                      isWestfieldAsset(shoppingCenter) ? westfieldMarker : redMarker,
                    scaledSize: new google.maps.Size(iconWidth, iconHeigth),
                  }}
                  onClick={(props, marker, e) => this.handleMarkerHover(props, marker, e, shoppingCenter, assetTypes.shoppingCenter.type)}
                />
              ))
              :
              this.props.officeList.map(office => (
                <GMMarker
                  key={office.id}
                  name={office.name}
                  position={{
                    lat: Number(office.latitude),
                    lng: Number(office.longitude),
                  }}
                  icon={{
                    url: yellowMarker,
                    scaledSize: new google.maps.Size(iconWidth, iconHeigth),
                  }}
                  onClick={(props, marker, e) => this.handleMarkerHover(props, marker, e, office, assetTypes.office.type)}
                />
              )))
          }
        </Map>
        }
      </div>
    );
  }
}

export default withRouter(connect(state => ({
  shoppingCenterList: state.shoppingCenterFilters.filteredShoppingCenterList,
  officeList: state.office.officeList,
  isOfficeSelected: state.office.isOfficeSelected,
  apiKey: state.google.mapsApiKey,
}), {})(AreaMap));
